// extracted by mini-css-extract-plugin
export default {"tooLargeWrapper":"Index-module__tooLargeWrapper--V3omB"};